import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

import {
  largeScreen,
  xSmallScreen
} from "../../../../shared/constants/screenSizes";

const CheckMark = styled.i.attrs(() => ({
  className: "fa fa-check"
}))`
  color: ${colors.primary};
  font-size: 11px;
  margin-right: 3px;

  @media screen and (max-width: ${largeScreen}px) {
    font-size: 10px;
    margin-right: 6px;
  }
`;

const Container = styled.div`
  align-items: center;
  background-color: ${colors.frostedGlass};
  display: flex;
  font-size: 12px;
  justify-content: center;
  margin-bottom: 10px;
  max-height: 40px;
  padding: 13px;
  text-align: center;

  @media screen and (max-width: ${xSmallScreen}px) {
    flex-direction: column;
    line-height: 15px;
    max-height: fit-content;
    padding: 15px 0 12px;

    i {
      font-size: 11px;
      margin: 0 0 3px;
    }

    div {
      width: 208px;
    }
  }
`;

export { CheckMark, Container };
